// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
.submission-poup-content {
  padding: 20px 24px;
}
.submission-poup-content .submission-card {
  background: #f6f8ff;
  border-radius: 16px;
  padding: 24px;
}
.submission-poup-content .submission-card .submission-details label {
  font-weight: 600;
  font-size: 16px;
  line-height: 30px;
  color: #4b5563;
  opacity: 0.5;
}
.submission-poup-content .submission-card .submission-details span {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1f2937;
}
.submission-poup-content .submission-card .gc-submission-user {
  display: flex;
  align-items: center;
  gap: 13px;
}
.submission-poup-content .submission-card .gc-submission-user .SU-avatar {
  width: 68px;
  height: 68px;
  background: #e7ecf0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #000000;
}
.submission-poup-content .submission-card .gc-submission-user .SU-info p {
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  color: #1f2937;
}
.submission-poup-content .submission-card .gc-submission-user .SU-info span {
  font-style: italic;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #4b5563;
  opacity: 0.5;
}
.submission-poup-content button.accept-btn {
  padding: 10px 12px;
  border: none;
  width: 119px;
  height: 40px;
  background: rgba(16, 185, 129, 0.1);
  border-radius: 6px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #6ACE6A;
  cursor: pointer;
}
.submission-poup-content button.recheck-btn {
  width: 119px;
  height: 40px;
  background: rgba(198, 106, 158, 0.1);
  border-radius: 6px;
  border: none;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #C66A9E;
  cursor: pointer;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
  border-top: 1px solid #ecf0f5;
  gap: 24px;
}

.esco-updload-btn {
  position: fixed;
  top: 8px;
  right: 60px;
}

.t-b {
  color: black !important;
}

/**/
.accpt-text {
  color: #0A6ED9;
  border: 1px solid #0A6ED9;
  border-radius: 8px;
  padding: 6px 8px;
}

.recheck-text {
  color: #C66A9E;
  border: 1px solid #C66A9E;
  border-radius: 8px;
  padding: 6px 8px;
}

th.AC-f,
th#checkboxVisitDetails {
  width: 55px;
}

th.AC-status {
  width: 250px !important;
}

.cw-heading p {
  color: #1f2937;
  padding-top: 3px;
}

.accepted-ques {
  color: #6ACE6A;
}

.rejected-ques {
  color: #C66A9E;
}

.w-390 {
  width: 390px;
}

.collapsible-header {
  display: flex;
  align-items: center;
  gap: 8px;
  -webkit-user-select: none;
          user-select: none;
}
.collapsible-header i {
  font-size: 14px;
  transition: transform 0.2s ease;
}
.collapsible-header:hover {
  opacity: 0.8;
}

.qa-notes-cell {
  position: relative;
  min-width: 200px;
}
.qa-notes-cell .qa-notes-display {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}
.qa-notes-cell .qa-notes-display:hover {
  background-color: #f3f4f6;
}
.qa-notes-cell .qa-notes-display:hover .qa-notes-edit-icon {
  opacity: 1;
}
.qa-notes-cell .qa-notes-display .image-text {
  flex: 1;
  word-break: break-word;
}
.qa-notes-cell .qa-notes-display .image-text.empty-text {
  color: #9ca3af;
  font-style: italic;
}
.qa-notes-cell .qa-notes-display .qa-notes-edit-icon {
  opacity: 0;
  transition: opacity 0.2s ease;
  color: #0A6ED9;
  font-size: 14px;
  cursor: pointer;
  padding: 4px;
}
.qa-notes-cell .qa-notes-display .qa-notes-edit-icon:hover {
  color: #0855a8;
}
.qa-notes-cell .qa-notes-edit {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.qa-notes-cell .qa-notes-edit .qa-notes-textarea {
  width: 100%;
  min-width: 250px;
  padding: 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.2s ease;
}
.qa-notes-cell .qa-notes-edit .qa-notes-textarea:focus {
  outline: none;
  border-color: #0A6ED9;
  box-shadow: 0 0 0 3px rgba(10, 110, 217, 0.1);
}
.qa-notes-cell .qa-notes-edit .qa-notes-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-start;
}
.qa-notes-cell .qa-notes-edit .qa-notes-actions button {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.qa-notes-cell .qa-notes-edit .qa-notes-actions button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.qa-notes-cell .qa-notes-edit .qa-notes-actions .qa-notes-save-btn {
  height: 32px;
  width: 84px;
}
.qa-notes-cell .qa-notes-edit .qa-notes-actions .qa-notes-save-btn i.pi-spinner {
  display: inline-block;
}
.qa-notes-cell .qa-notes-edit .qa-notes-actions .qa-notes-cancel-btn {
  height: 32px;
  border: 1px solid #1E38A9;
  width: 84px;
}
.qa-notes-cell .qa-notes-edit .qa-notes-actions .qa-notes-cancel-btn:hover:not(:disabled) {
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/colors.scss","webpack://./src/app/shared/visit-details/visit-details.component.scss"],"names":[],"mappings":"AAAA;;EAAA;ACCA;EACE,kBAAA;AAGF;AAFE;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;AAIJ;AAFM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AAIR;AAFM;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAIR;AADI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAGN;AAFM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAIR;AADQ;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAGV;AADQ;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AAGV;AAEE;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,mCAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cD5DI;EC6DJ,eAAA;AAAJ;AAGE;EACE,YAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cDrEC;ECsED,eAAA;AADJ;;AAIA;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;AADF;;AAGA;EACE,eAAA;EACA,QAAA;EACA,WAAA;AAAF;;AAGA;EACE,uBAAA;AAAF;;AAEA,GAAA;AACA;EACE,cDrGY;ECsGZ,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AACA;EACE,cDjGG;ECkGH,yBAAA;EACA,kBAAA;EACA,gBAAA;AAEF;;AAAA;;EAEE,WAAA;AAGF;;AADA;EACE,uBAAA;AAIF;;AADE;EACE,cAAA;EACA,gBAAA;AAIJ;;AADA;EACE,cDzHM;AC6HR;;AAFA;EACE,cDvHG;AC4HL;;AAHA;EACE,YAAA;AAMF;;AAHA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;UAAA,iBAAA;AAMF;AAJE;EACE,eAAA;EACA,+BAAA;AAMJ;AAHE;EACE,YAAA;AAKJ;;AADA;EACE,kBAAA;EACA,gBAAA;AAIF;AAFE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,sCAAA;AAIJ;AAFI;EACE,yBAAA;AAIN;AAFM;EACE,UAAA;AAIR;AAAI;EACE,OAAA;EACA,sBAAA;AAEN;AAAM;EACE,cAAA;EACA,kBAAA;AAER;AAEI;EACE,UAAA;EACA,6BAAA;EACA,cDzLQ;EC0LR,eAAA;EACA,eAAA;EACA,YAAA;AAAN;AAEM;EACE,cAAA;AAAR;AAKE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAHJ;AAKI;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,kCAAA;AAHN;AAKM;EACE,aAAA;EACA,qBDtNM;ECuNN,6CAAA;AAHR;AAOI;EACE,aAAA;EACA,QAAA;EACA,2BAAA;AALN;AAOM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AALR;AAOQ;EACE,YAAA;EACA,mBAAA;AALV;AASM;EACE,YAAA;EACA,WAAA;AAPR;AAQQ;EACE,qBAAA;AANV;AAUM;EACE,YAAA;EACA,yBAAA;EACA,WAAA;AARR;AAUQ;EACE,YAAA;AARV","sourcesContent":["/**\n * Created by Inzamam Janjua on 18/05/2023.\n */\n\n\n// Primary Color Palette\n\n$primaryBlue: #0A6ED9;\n$GreenBlue: #1C75BC;\n$Orange: #EF896A;\n$DarkSilver: #6C6D70;\n$BrightYellow: #F9A51D;\n$Green: #6ACE6A;\n$Greenlight: #7AEC7A;\n$GreenDark: #5CB85C;\n$white: #fff;\n$black: #000;\n$red:#C66A9E;\n// Standard System Colors\n\n$errorRed: #FF3C3C;\n$darkRed: #C11574;\n$lightRed: #FDF2FA;\n$successGreen: #10B981;\n$lightGreen: #ECFAF5;\n$lightOrange: #FFF2EB;\n$notificationYellow: #F9A51D;\n$lightBlue:rgba(226, 238, 255, 1);\n$headingText: #1E38A9;\n","@import \"../../../assets/styles/colors.scss\";\n.submission-poup-content {\n  padding: 20px 24px;\n  .submission-card {\n    background: #f6f8ff;\n    border-radius: 16px;\n    padding: 24px;\n    .submission-details {\n      label {\n        font-weight: 600;\n        font-size: 16px;\n        line-height: 30px;\n        color: #4b5563;\n        opacity: 0.5;\n      }\n      span {\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 30px;\n        color: #1f2937;\n      }\n    }\n    .gc-submission-user {\n      display: flex;\n      align-items: center;\n      gap: 13px;\n      .SU-avatar {\n        width: 68px;\n        height: 68px;\n        background: #e7ecf0;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-style: normal;\n        font-weight: 500;\n        font-size: 20px;\n        line-height: 30px;\n        text-align: center;\n        color: #000000;\n      }\n      .SU-info {\n        p {\n          font-style: normal;\n          font-weight: 600;\n          font-size: 24px;\n          line-height: 30px;\n          color: #1f2937;\n        }\n        span {\n          font-style: italic;\n          font-weight: 500;\n          font-size: 16px;\n          line-height: 30px;\n          color: #4b5563;\n          opacity: 0.5;\n        }\n      }\n    }\n  }\n  button.accept-btn {\n    padding: 10px 12px;\n    border: none;\n    width: 119px;\n    height: 40px;\n    background: rgba(16, 185, 129, 0.1);\n    border-radius: 6px;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 20px;\n    color: $Green;\n    cursor: pointer;\n  }\n\n  button.recheck-btn {\n    width: 119px;\n    height: 40px;\n    background: rgba(198, 106, 158, 0.1);\n    border-radius: 6px;\n    border: none;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 20px;\n    color: $red;\n    cursor: pointer;\n  }\n}\n.button-container {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 20px;\n  border-top: 1px solid #ecf0f5;\n  gap: 24px;\n}\n.esco-updload-btn {\n  position: fixed;\n  top: 8px;\n  right: 60px;\n}\n\n.t-b {\n  color: black !important;\n}\n/**/\n.accpt-text {\n  color: $primaryBlue;\n  border: 1px solid $primaryBlue;\n  border-radius: 8px;\n  padding: 6px 8px\n}\n.recheck-text {\n  color: $red;\n  border: 1px solid $red;\n  border-radius: 8px;\n  padding: 6px 8px\n}\nth.AC-f,\nth#checkboxVisitDetails {\n  width: 55px;\n}\nth.AC-status {\n  width: 250px !important;\n}\n.cw-heading {\n  p {\n    color: #1f2937;\n    padding-top: 3px;\n  }\n}\n.accepted-ques {\n  color: $Green;\n}\n.rejected-ques {\n  color: $red;\n}\n.w-390{\n  width: 390px;\n}\n\n.collapsible-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  user-select: none;\n\n  i {\n    font-size: 14px;\n    transition: transform 0.2s ease;\n  }\n\n  &:hover {\n    opacity: 0.8;\n  }\n}\n\n.qa-notes-cell {\n  position: relative;\n  min-width: 200px;\n\n  .qa-notes-display {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    padding: 4px 8px;\n    border-radius: 4px;\n    transition: background-color 0.2s ease;\n\n    &:hover {\n      background-color: #f3f4f6;\n\n      .qa-notes-edit-icon {\n        opacity: 1;\n      }\n    }\n\n    .image-text {\n      flex: 1;\n      word-break: break-word;\n\n      &.empty-text {\n        color: #9ca3af;\n        font-style: italic;\n      }\n    }\n\n    .qa-notes-edit-icon {\n      opacity: 0;\n      transition: opacity 0.2s ease;\n      color: $primaryBlue;\n      font-size: 14px;\n      cursor: pointer;\n      padding: 4px;\n\n      &:hover {\n        color: darken($primaryBlue, 10%);\n      }\n    }\n  }\n\n  .qa-notes-edit {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    .qa-notes-textarea {\n      width: 100%;\n      min-width: 250px;\n      padding: 8px;\n      border: 1px solid #d1d5db;\n      border-radius: 4px;\n      font-size: 14px;\n      font-family: inherit;\n      resize: vertical;\n      transition: border-color 0.2s ease;\n\n      &:focus {\n        outline: none;\n        border-color: $primaryBlue;\n        box-shadow: 0 0 0 3px rgba($primaryBlue, 0.1);\n      }\n    }\n\n    .qa-notes-actions {\n      display: flex;\n      gap: 8px;\n      justify-content: flex-start;\n\n      button {\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        padding: 6px 12px;\n        border: none;\n        border-radius: 4px;\n        font-size: 14px;\n        font-weight: 500;\n        cursor: pointer;\n        transition: all 0.2s ease;\n\n        &:disabled {\n          opacity: 0.6;\n          cursor: not-allowed;\n        }\n      }\n\n      .qa-notes-save-btn {\n        height: 32px;\n        width: 84px;\n        i.pi-spinner {\n          display: inline-block;\n        }\n      }\n\n      .qa-notes-cancel-btn {\n        height: 32px;\n        border: 1px solid #1E38A9;\n        width: 84px;\n\n        &:hover:not(:disabled) {\n          border: none;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
